import React from 'react';
import { XCircleIcon } from 'lucide-react';
export const ProblemSection: React.FC = () => {
  const problems = ['Perder 3 horas buscando ejercicios en YouTube y terminar con una sesión genérica que no le sirve a nadie.', "Que tus jugadores/atletas no mejoren porque les das 'de todo un poco' sin criterio real.", 'Arrancar desde cero cada semana porque no tenés un sistema que te guíe.'];
  return <section className="py-12 px-4 bg-white" data-id="element-212">
      <div className="max-w-4xl mx-auto" data-id="element-213">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10 leading-tight" data-id="element-214">
          Si ya probaste armar entrenamientos "a ojo" y te frustraste cuando no
          funcionaron...
        </h2>

        <p className="text-xl text-center text-gray-600 mb-8 font-medium" data-id="element-215">
          Sabes lo que es:
        </p>

        <div className="grid gap-4 mb-10" data-id="element-216">
          {problems.map((problem, index) => <div key={index} className="flex items-start gap-4 p-5 rounded-xl bg-red-50 border border-red-100" data-id="element-217">
              <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-218" />
              <p className="text-lg text-gray-800" data-id="element-219">{problem}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-220">
          <p className="text-2xl font-bold text-gray-900" data-id="element-221">
            No es falta de ganas.{' '}
            <span className="text-red-600" data-id="element-222">Es falta de estructura.</span>
          </p>
        </div>
      </div>
    </section>;
};